import { isValidPhoneNumber } from 'libphonenumber-js';
import { validateEmail } from 'src/utils/common';
import * as Yup from 'yup';

export default Yup.object().shape({
  fullName: Yup.string().required('SCHEMA_ERRORS.FULL_NAME_REQUIRED'),
  email: Yup.string()
    .test('email', 'SCHEMA_ERRORS.EMAIL_FORMAT_INVALID', validateEmail)
    .required('SCHEMA_ERRORS.EMAIL_REQUIRED'),
  phone: Yup.string()
    .test('phone', 'SCHEMA_ERRORS.PHONE_INVALID', value => {
      const phoneNumber = isValidPhoneNumber(`+${value}`);
      return phoneNumber;
    })
    .required('SCHEMA_ERRORS.PHONE_REQUIRED'),
  role: Yup.object()
    .typeError('SCHEMA_ERRORS.CLIENT_DETAIL_FORM.ROLE_REQUIRED')
    .required('SCHEMA_ERRORS.CLIENT_DETAIL_FORM.ROLE_REQUIRED')
});
